"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchPublicReviews = exports.getPublicReview = exports.getPublicReviews = exports.deleteReviewRelation = exports.postReviewRelation = exports.putReviewOrganization = exports.putReviewAccessibility = exports.deleteReviewPermission = exports.postReviewPermission = exports.putReviewAction = exports.postReview = exports.putReview = exports.getReview = exports.getReviews = void 0;

var common_1 = require("../common");

var root_1 = require("./root");

var reviewsAuthorizedPath = root_1.pimAuthorized + '/reviews/';
var reviewsPublicPath = root_1.pimPublic + '/reviews/';

var getReviews = function getReviews(authentication, queryParameters) {
  return common_1.get(authentication, reviewsAuthorizedPath, queryParameters);
};

exports.getReviews = getReviews;

var getReview = function getReview(authentication, id) {
  return common_1.get(authentication, reviewsAuthorizedPath + id);
};

exports.getReview = getReview;

var putReview = function putReview(authentication, review) {
  return common_1.put(authentication, reviewsAuthorizedPath + review.id, review);
};

exports.putReview = putReview;

var postReview = function postReview(authentication, review) {
  return common_1.post(authentication, reviewsAuthorizedPath, review);
};

exports.postReview = postReview;

var putReviewAction = function putReviewAction(authentication, id, action, data) {
  return common_1.putSub(authentication, reviewsAuthorizedPath, id, action, data);
};

exports.putReviewAction = putReviewAction;

var postReviewPermission = function postReviewPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, reviewsAuthorizedPath, id, permission);
};

exports.postReviewPermission = postReviewPermission;

var deleteReviewPermission = function deleteReviewPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, reviewsAuthorizedPath, id, permissionId);
};

exports.deleteReviewPermission = deleteReviewPermission;

var putReviewAccessibility = function putReviewAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, reviewsAuthorizedPath, id, accessibility);
};

exports.putReviewAccessibility = putReviewAccessibility;

var putReviewOrganization = function putReviewOrganization(authentication, id, accessibility) {
  return common_1.putEntityOrganization(authentication, reviewsAuthorizedPath, id, accessibility);
};

exports.putReviewOrganization = putReviewOrganization;

var postReviewRelation = function postReviewRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, reviewsAuthorizedPath, id, relation);
};

exports.postReviewRelation = postReviewRelation;

var deleteReviewRelation = function deleteReviewRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, reviewsAuthorizedPath, id, relationId);
};

exports.deleteReviewRelation = deleteReviewRelation;

var getPublicReviews = function getPublicReviews(authentication, queryParameters) {
  return common_1.get(authentication, reviewsPublicPath, queryParameters);
};

exports.getPublicReviews = getPublicReviews;

var getPublicReview = function getPublicReview(authentication, id) {
  return common_1.get(authentication, reviewsPublicPath + id);
};

exports.getPublicReview = getPublicReview;

var searchPublicReviews = function searchPublicReviews(authentication, queryParameters) {
  return common_1.get(authentication, reviewsPublicPath + 'search', queryParameters);
};

exports.searchPublicReviews = searchPublicReviews;